import { render } from "./ButtonHeaderTooltip.vue?vue&type=template&id=0cfc4886"
import script from "./ButtonHeaderTooltip.vue?vue&type=script&lang=js"
export * from "./ButtonHeaderTooltip.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__